import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/contactUs/registeringComplaintStyle';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForward from '@material-ui/icons/ArrowForward';
import { BodyM } from 'components/Typography/Typography';
import classNames from 'classnames';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ISingleSuggestionProps {
	name: string;
	onClick: () => void;
	active?: boolean;
	onMouseOver: () => void;
	onMouseOut: () => void;
}

const SingleSuggestion = ({ name, onClick, active, onMouseOut, onMouseOver }: ISingleSuggestionProps) => {
	const classes = useStyles();

	return (
		<div
			onClick={onClick}
			className={classNames(classes.singleSuggestionWrapper, { [classes.activeSingleSuggestionWrapper]: active })}
			onMouseOut={onMouseOut}
			onMouseOver={onMouseOver}
		>
			<BodyM disableMargin color="primary-light">
				{name}
			</BodyM>
			<ArrowForward />
		</div>
	);
};

export default SingleSuggestion;
